"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const compact_1 = __importDefault(require("lodash/compact"));
const timeago_js_1 = require("timeago.js");
const DownloaderContext_1 = require("context/DownloaderContext");
const CsvHelper_1 = require("utils/CsvHelper");
const HelperUtils_1 = require("utils/HelperUtils");
const Button_1 = __importDefault(require("components/design-system/Button"));
const Dropdown_1 = __importDefault(require("components/design-system/dropdown/Dropdown"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const ConditionalWrapper_1 = __importDefault(require("./ConditionalWrapper"));
require("./ExportCSVButton.scss");
const ExportCSVButton = ({ buttonClass, ready, getLatestCSV, exportCSV }) => {
    const [isExporting, setIsExporting] = (0, react_1.useState)(null);
    const [latestCSVData, setLatestCSVData] = (0, react_1.useState)(null);
    const { isDownloadInProcess, setIsDownloadInProcess, setupSocket, setActiveQueue } = (0, DownloaderContext_1.useDownloader)();
    const handleExportCSV = () => {
        setupSocket();
        setIsExporting(true);
        setActiveQueue('increment');
        setIsDownloadInProcess(true);
        exportCSV();
    };
    const getData = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield getLatestCSV();
        setLatestCSVData(data);
    }), [getLatestCSV]);
    (0, react_1.useEffect)(() => {
        if (ready)
            getData();
        // eslint-disable-next-line
    }, [ready]);
    (0, react_1.useEffect)(() => {
        if (isDownloadInProcess) {
            setIsExporting(true);
        }
        if (isExporting && !isDownloadInProcess) {
            setTimeout(() => {
                getData();
                setIsExporting(false);
            }, 3500);
        }
        // eslint-disable-next-line
    }, [isDownloadInProcess]);
    const listDropdown = (0, compact_1.default)([
        latestCSVData && {
            additionalText: (react_1.default.createElement("div", { className: "flex flex-col" },
                react_1.default.createElement("p", null, (0, HelperUtils_1.getObjectiveLocale)('Download Previous CSV')),
                react_1.default.createElement("span", { className: "typography-h100 text-n-800" }, (0, timeago_js_1.format)(latestCSVData === null || latestCSVData === void 0 ? void 0 : latestCSVData.createdAt)))),
            iconName: 'icon-file_download',
            onClick: () => (0, CsvHelper_1.downloadExportCSV)(latestCSVData === null || latestCSVData === void 0 ? void 0 : latestCSVData.file),
            customClass: 'w-[224px]'
        },
        {
            text: 'Re-generate New CSV',
            iconName: 'icon-autorenew',
            onClick: () => handleExportCSV()
        }
    ]);
    return (react_1.default.createElement("div", { className: "flex" },
        isExporting && (react_1.default.createElement("div", { className: "flex items-center mr-[24px]" },
            !isDownloadInProcess ? (react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-check", size: 24, fillColor: "var(--g-600)", customClass: "mr-[4px]" })) : (react_1.default.createElement("div", { className: "loading-export flex" },
                react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-cached", size: 24, fillColor: "var(--n-600)", customClass: "mr-[4px]" }))),
            react_1.default.createElement("p", { className: "typography-button text-n-900" },
                (0, HelperUtils_1.getObjectiveLocale)(isDownloadInProcess ? 'Preparing' : 'Preparation Done'),
                isDownloadInProcess ? '...' : '!'))),
        react_1.default.createElement(ConditionalWrapper_1.default, { condition: latestCSVData, wrapper: (children) => (react_1.default.createElement(Dropdown_1.default, null,
                react_1.default.createElement(Dropdown_1.default.Trigger, { disabled: !ready }, children),
                react_1.default.createElement(Dropdown_1.default.MenuItems, { options: listDropdown, customClass: `w-[224px] ${buttonClass}`, position: "right", type: "fixed" }))) },
            react_1.default.createElement(ButtonComponent, { isDisabled: !ready, onClick: () => !latestCSVData && handleExportCSV() }))));
};
const ButtonComponent = ({ isDisabled, onClick }) => {
    return (react_1.default.createElement(Button_1.default.Secondary, { disabled: isDisabled, stopPropagation: false, onClick: onClick },
        react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-file_download", size: 20, fillColor: "var(--n-600)", customClass: "pr-[16px]", dataCy: "export-csv" }),
        (0, HelperUtils_1.getObjectiveLocale)('Export CSV')));
};
exports.default = ExportCSVButton;
